<script lang="ts">
import { computed, defineComponent } from "vue";

import * as layoutComponents from "./layouts";

const allowedLayoutNames = ["default", "tight", "error"];
export default defineComponent({
  components: {
    ...layoutComponents,
  },
  props: {
    name: {
      type: String,
      default: "default",
      validator: (value: string) => allowedLayoutNames.includes(value),
    },
    arguments: {
      type: String,
      default: "default",
      validator: (value: string) => allowedLayoutNames.includes(value),
    },
  },
  setup(props) {
    const layoutComponent = computed(() => {
      return `layout-${props.name}`;
    });
    return {
      layoutComponent,
    };
  },
});
</script>

<template>
  <component :is="layoutComponent">
    <slot />
  </component>
</template>
